//
// Purpose: SAMB - new Goal
// Author: Ronny Van Elewyck
// Version: 1.0
// Creation Date: 11.06.2020
// Modification Date: 15.10.2020
//

// installed components
import React from "react";
import Tooltip from "react-bootstrap/Tooltip";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";

// created components

// config files
import {
  saveClass5,
  cancelClass5,
  goalMessage4,
  classErrorMessage,
} from "../../config.json";

const NewGoalForm = ({ newItem, cancelItem }) => {
  //
  // format row of table
  //

  let title = "Nieuwe doelstelling aanmaken";

  const [label, setValue1] = React.useState("");

  const sizeLine3 = 500;

  const [showError1, setShowError1] = React.useState("");
  const [isError1, setError1] = React.useState(false);

  React.useEffect(() => {
    // check uppercase first letter
    const regex = /^[A-Z]/;
    const found = label.match(regex);

    if (
      found === null ||
      label === "" ||
      label.length < 5 ||
      label.length > 500
    ) {
      setError1(true);
      setShowError1(goalMessage4);
    } else {
      setError1(false);
      setShowError1("");
    }
  }, [label]);

  const addLineBreaks = (string) =>
    string.split("\n").map((text, index) => (
      <React.Fragment key={`${text}-${index}`}>
        {text}
        <br />
      </React.Fragment>
    ));

  function renderTooltip(title) {
    return <Tooltip id="button-tooltip">{title}</Tooltip>;
  }

  return (
    <div>
      <div>
        <OverlayTrigger
          placement="left"
          delay={{ show: 250, hide: 400 }}
          overlay={renderTooltip("terug")}
        >
          <button
            className={cancelClass5}
            onClick={() => cancelItem()}
          ></button>
        </OverlayTrigger>
        {!isError1 && (
          <OverlayTrigger
            placement="left"
            delay={{ show: 250, hide: 400 }}
            overlay={renderTooltip("bewaar")}
          >
            <button
              className={saveClass5}
              onClick={() =>
                newItem({
                  label,
                })
              }
            ></button>
          </OverlayTrigger>
        )}
      </div>

      <div className="table-responsive">
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>
                <h4>
                  <span className="badge badge-info d-flex justify-content-center">
                    {title}
                  </span>
                </h4>
              </td>
            </tr>
            <tr>
              <td>
                {isError1 && (
                  <div className={classErrorMessage}>{showError1}</div>
                )}
                <input
                  type="text"
                  className="form-control"
                  value={label}
                  onChange={(e) => setValue1(e.currentTarget.value)}
                  maxLength={sizeLine3}
                />
                <h1>{addLineBreaks("")}</h1>
                <h1>{addLineBreaks("")}</h1>
                <h1>{addLineBreaks("")}</h1>
                <h1>{addLineBreaks("")}</h1>
                <h1>{addLineBreaks("")}</h1>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default NewGoalForm;
